module.exports = __webpack_public_path__ + "img/icon-popup-warning.d419816c.png";